import { render, staticRenderFns } from "./OctAddCircle.vue?vue&type=template&id=72f64865&scoped=true&"
import script from "./OctAddCircle.vue?vue&type=script&lang=js&"
export * from "./OctAddCircle.vue?vue&type=script&lang=js&"
import style0 from "./OctAddCircle.vue?vue&type=style&index=0&id=72f64865&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f64865",
  null
  
)

export default component.exports